// TitleScene.js
import Phaser from "phaser";

export default class TitleScene extends Phaser.Scene {
  constructor() {
    super("TitleScene");
  }

  preload() {
    // optionally load a logo or background
    this.load.image("logo", "/assets/sprites/logo-aetherwyn.png");
  }

  create() {
    // optional background
    this.add.image(400, 250, "logo").setOrigin(0.5).setScale(0.79);

    // Smaller text: "Start Game"
    const startText = this.add.text(400, 520, "Start Game", {
      fontSize: "32px",
      color: "#ffffaa",
      padding: { left: 10, right: 10, top: 5, bottom: 5 },
      fontFamily: "monospace",
    }).setOrigin(0.5);

    // Make "Start Game" clickable
    startText.setInteractive({ useHandCursor: true });
    startText.on("pointerdown", () => {
      // Switch to CharacterSelectScene, or directly to WorldScene
      this.scene.start("CharacterSelectScene");
    });
  }
}
